"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_CARDS_POSITIONS = exports.VIDEO_CARD_TYPES = exports.VideoCards = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var card_1 = tslib_1.__importDefault(require("./card/card"));
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
Object.defineProperty(exports, "VIDEO_CARD_TYPES", { enumerable: true, get: function () { return types_1.VIDEO_CARD_TYPES; } });
var positions_1 = require("@wix/wix-vod-constants/dist/video-cards/positions");
Object.defineProperty(exports, "VIDEO_CARDS_POSITIONS", { enumerable: true, get: function () { return positions_1.VIDEO_CARDS_POSITIONS; } });
// @ts-expect-error
var constants_1 = require("@wix/wix-vod-cards/dist/src/cards-module/constants");
var anchorPointsMap = (_a = {},
    _a[positions_1.VIDEO_CARDS_POSITIONS.BOTTOM_LEFT] = constants_1.ANCHOR_POINTS.BOTTOM_LEFT,
    _a[positions_1.VIDEO_CARDS_POSITIONS.BOTTOM_RIGHT] = constants_1.ANCHOR_POINTS.BOTTOM_RIGHT,
    _a);
var getPlayerCardData = function (_a) {
    var cardData = _a.cardData, index = _a.index, contentNode = _a.contentNode;
    var id = cardData.clientId, from = cardData.from, to = cardData.to;
    var order = index;
    var hasDynamicContent = cardData.type === types_1.VIDEO_CARD_TYPES.SOCIAL;
    return { id: id, from: from, to: to, order: order, contentNode: contentNode, hasDynamicContent: hasDynamicContent };
};
var VideoCardWrap = /** @class */ (function (_super) {
    tslib_1.__extends(VideoCardWrap, _super);
    function VideoCardWrap(props) {
        var _this = _super.call(this, props) || this;
        _this.contentNode = document.createElement('div');
        _this.setCardAccessible = function (isAccessible) {
            _this.setState({ isAccessible: isAccessible });
        };
        var player = _this.props.player;
        _this.state = { isAccessible: false };
        player.onCardHidden(function () { return _this.setCardAccessible(false); });
        player.onCardShown(function () { return _this.setCardAccessible(true); });
        return _this;
    }
    VideoCardWrap.prototype.getPlayerCardData = function (props) {
        var cardData = props.cardData, index = props.index;
        var contentNode = this.contentNode;
        return getPlayerCardData({ contentNode: contentNode, cardData: cardData, index: index });
    };
    VideoCardWrap.prototype.componentDidMount = function () {
        var _this = this;
        var player = this.props.player;
        player
            .addCard(this.getPlayerCardData(this.props))
            .then(function () { return _this.updateActiveCard(); });
    };
    VideoCardWrap.prototype.componentDidUpdate = function (oldProps) {
        var _this = this;
        var newCardData = this.getPlayerCardData(this.props);
        var oldCardData = this.getPlayerCardData(oldProps);
        if (!(0, lodash_1.isEqual)(oldCardData, newCardData)) {
            var player = this.props.player;
            player.updateCards([newCardData]).then(function () { return _this.updateActiveCard(); });
        }
    };
    VideoCardWrap.prototype.updateActiveCard = function () {
        var _a = this.props, player = _a.player, isActive = _a.isActive, cardData = _a.cardData;
        if (!isActive) {
            return;
        }
        player.setActiveCard(cardData.clientId);
    };
    VideoCardWrap.prototype.componentWillUnmount = function () {
        var _a = this.props, player = _a.player, cardData = _a.cardData;
        if (player && player.removeCard) {
            player.removeCard(cardData.clientId);
        }
    };
    VideoCardWrap.prototype.render = function () {
        var _a = this.props, onCardClick = _a.onCardClick, labels = _a.labels, cardData = _a.cardData;
        var isAccessible = this.state.isAccessible;
        return react_dom_1.default.createPortal(react_1.default.createElement(card_1.default, { labels: labels, isAccessible: isAccessible, cardData: cardData, onCardClick: onCardClick }), this.contentNode);
    };
    return VideoCardWrap;
}(react_1.default.Component));
var getCardsAnchorPoint = function (cardsData) {
    // all cards contain position value, and it's the same for all cards
    var _a = tslib_1.__read(cardsData, 1), sampleCard = _a[0];
    return anchorPointsMap[sampleCard.position];
};
var VideoCards = /** @class */ (function (_super) {
    tslib_1.__extends(VideoCards, _super);
    function VideoCards() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cardsConfig = {
            anchorPoint: constants_1.ANCHOR_POINTS,
        };
        return _this;
    }
    VideoCards.prototype.componentDidUpdate = function () {
        this.updateCardsConfig();
    };
    VideoCards.prototype.updateCardsConfig = function () {
        var _a = this.props, player = _a.player, cardsData = _a.cardsData;
        if (!player || (0, lodash_1.isEmpty)(player) || (0, lodash_1.isEmpty)(cardsData)) {
            return;
        }
        var newAnchorPoint = getCardsAnchorPoint(cardsData);
        if (newAnchorPoint !== this.cardsConfig.anchorPoint) {
            player.setAnchorPoint(newAnchorPoint);
            this.cardsConfig.anchorPoint = newAnchorPoint;
        }
        // TODO update cards orientation
    };
    VideoCards.prototype.render = function () {
        var _a = this.props, player = _a.player, cardsData = _a.cardsData, onCardClick = _a.onCardClick, labels = _a.labels, activeVideoCard = _a.activeVideoCard;
        if (!player || (0, lodash_1.isEmpty)(player)) {
            return null;
        }
        return (react_1.default.createElement(react_1.default.Fragment, null, cardsData.map(function (cardData, index) { return (react_1.default.createElement(VideoCardWrap, { key: cardData.clientId, player: player, labels: labels, onCardClick: onCardClick, cardData: cardData, index: index, isActive: !!activeVideoCard &&
                cardData.clientId === activeVideoCard.clientId })); })));
    };
    VideoCards.propTypes = {
        player: prop_types_1.default.object,
        cardsData: prop_types_1.default.array,
        onCardClick: prop_types_1.default.func,
        activeVideoCard: prop_types_1.default.object,
        labels: prop_types_1.default.object,
    };
    VideoCards.defaultProps = {
        onCardClick: lodash_1.noop,
    };
    return VideoCards;
}(react_1.default.PureComponent));
exports.VideoCards = VideoCards;
exports.default = VideoCards;
//# sourceMappingURL=video-cards.js.map